import { setLoadTrigger } from "@views/macros/verify-box";

(function() {
  const verifyBoxTrigger = document.querySelector(".host-profile__verify--verified > button");
  setLoadTrigger(verifyBoxTrigger, { events: ["mouseover", "focus"] });
})();

(function() {
  /** 联系房东按钮 */
  const button = document.getElementById("consultButton");
  if (!button) return;
  const chatPath = button.href;
  const toDxUid = button.getAttribute("data-uid");
  const productId = button.getAttribute("data-product-id");
  const orderId = button.getAttribute("data-order-id");

  button.addEventListener("click", onImButtonClick, false);

  function onImButtonClick(e) {
    if (!toDxUid) {
      e.preventDefault();
      return showToast("对方暂未开通IM功能！");
    }
    if (orderId) {
      this.href = `${chatPath}?orderId=${orderId}`;
      return;
    }
    if (productId) {
      const params = window.$bookingParams || {};
      const hasDate = params.checkinDate && params.checkoutDate;
      if (hasDate) {
        this.href = `${chatPath}?productId=${productId}&startDate=${params.checkinDate}&endDate=${params.checkoutDate}`;
        return;
      }
      const bookingMain = document.getElementById("bookingMain");
      if (!bookingMain) return;
      e.preventDefault();
      showToast("咨询房东前，请您先选择入住和退房的时间哦");
      bookingMain.style.animation = "highlight-box 0.8s linear infinite";
      setTimeout(function() {
        bookingMain.style.animation = "";
      }, 2400);
    }
  }

  function showToast(c) {
    var toast = document.getElementById("consultToast");
    if (!toast) return alert(c);
    toast.innerHTML = c;
    toast.style.display = "block";
    setTimeout(function() {
      toast.style.display = "none";
    }, 2400);
  }
})();

require("./product.less");